module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kd-Lb.5e0188b4.png";